import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class CAT2025JSONIDService {
    public Cat2025person = {
        "@context": "https://schema.org/",
        "@type": "Person",
        "name": "Indrajeet Singh",
        "url": "https://www.iquanta.in/",
        "image": "https://media.iquanta.in/ui_images/public_portal_img/ava.jpg",
        "sameAs": [
            "https://www.facebook.com/IndrajeetiQuanta",
            "https://www.linkedin.com/in/indralion/"
        ],
        "jobTitle": "CEO",
        "worksFor": {
            "@type": "Organization",
            "name": "iQuanta"
        }
    }
    public CAT2025FAQS = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": "WHEN IS CAT 2025 EXAM?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "The CAT Exam is conducted every year in November. Generally, it has been noticed that CAT is conducted on the last Sunday of November. According to the previous trend, we can assume that the CAT 2025 exam will be conducted on the 30th of November 2025."
            }
        }, {
            "@type": "Question",
            "name": "CAT 2025 preparation ONLINE VS OFFLINE?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Mode of preparation can have a huge impact on one’s preparation. Generally, Online mode of preparation is considered to be more suitable than offline coaching, considering it provides updated and easily accessible content. When talking of factors like affordability and time efficiency online mode again has an edge over traditional offline coaching."
            }
        }, {
            "@type": "Question",
            "name": "When will the CAT registration 2025 start?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "CAT 2025 Aspirants can expect CAT 2025 registrations to be opened by 1st week of August."
            }
        }, {
            "@type": "Question",
            "name": "When should one start preparing for CAT 2025?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Considering the increase in competition one should start preparing of CAT 2025 as early as possible. Generally anywhere between 1.5 years & 6 months is considered enough time for CAT Preparation."
            }
        }, {
            "@type": "Question",
            "name": "Which is the best CAT 2025 Course?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "There are various CAT courses available in the market, yet iQuanta’s CAT 2025 Course is considered to be the most liked course by aspirants. Offerings like Non-engineers Quant conceptual videos, Engineers VARC Module, Dual mode of learning, and 24/7 doubt-solving facility make the Course interesting for the aspirants. With iQuanta one can have an unusual edge in the competition, as the content is highly relevant. Every year, several questions in the CAT exam are similar to what was taught in the iQuanta CAT classes."
            }
        }, {
            "@type": "Question",
            "name": "When can the CAT 2025 results be expected?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "CAT 2025 results are declared every year at the end of December(tentative)."
            }
        }, {
            "@type": "Question",
            "name": "Which subjects should you prepare for the CAT 2025 exam?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "CAT Exam has 3 sections particularly known as VARC (Verbal Ability and Reading Comprehension), LRDI (Logical Reasoning and Data Interpretation) and QA (Quantitative Aptitude)"
            }
        }, {
            "@type": "Question",
            "name": "Which Coaching provides the best CAT 2025 Course?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "iQuanta provides the best CAT 2025 COURSE."
            }
        }, {
            "@type": "Question",
            "name": "Which IIM would conduct CAT 2025?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "CAT Exam is conducted by the top IIMs on a rotational basis. Which we can’t predict before any official announcement made my the Conducting Body."
            }
        }, {
            "@type": "Question",
            "name": "How to enrol for iQuanta’s CAT 2025 Course?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "One can directly visit www.iQuanta.in to enrol for CAT 2025 Course."
            }
        }]
    }
    public Cat2025BreadcrumbList = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "iQuanta",
            "item": "https://www.iquanta.in/"
        }, {
            "@type": "ListItem",
            "position": 2,
            "name": "CAT 2025 Course",
            "item": "https://www.iquanta.in/cat-2025"
        }]
    }

    public CAT2025Product = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": "CAT 2025 Course",
        "image": [
            "https://media.iquanta.in/ui_images/cat-coaching.webp"
        ],
        "brand": {
            "@type": "Brand",
            "name": "iQuanta"
        },
        "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5",
            "ratingCount": "1370"
        },
        "offers": {
            "@type": "AggregateOffer",
            "lowPrice": "31999",
            "offerCount": "77001",
            "highPrice": "109000",
            "priceCurrency": "INR"
        }
    }

     constructor(public http: HttpClient, public AppConfig: AppConfig) { }

       homeEnquiry(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.post(this.AppConfig.LOGIN_ENDPOINT + 'homepage_enquiry_form_post', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

   callback(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'call_back/', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }

   getPagewiseCourses(type: any, page: any, year: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'CoursesGetBasedOnCategoryAndYear?page_type=' + page + '&category_name=' + type + '&year=' + year, httpOptions)
      .pipe(map((response: any) => response));
  }

    getBannerVideos() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT1 + 'HomePageVideoList', httpOptions)
      .pipe(map((response: any) => response));
  }

   courseDetails(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'course?course_id=' + id, httpOptions)
      .pipe(map((response: any) => response));
  }

    saveFeeWaiver(fd: any) {
    return this.http.post(this.AppConfig.API_ENDPOINT + 'MockFeeWaiverList', fd)
      .pipe(map((response: any) => response));
  }

  saveUserLEadForm(reqData:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.post('https://itech-api-prod.iquanta.in/api/mbr/home/v1/sent/enquiry', reqData, httpOptions)
    .pipe(map((response: any) => response));
}
updateUserLeadForm(reqData:any, id:any) {
  const httpOptions = {
    headers: new HttpHeaders({
      'secret': '6669ac7eeb6f363a778463e0',
      'token': '6669ac7eeb6f363a778463e0'
    })
  };

  return this.http.patch('https://itech-api-prod.iquanta.in/api/mbr/home/v1/update/'+id, reqData, httpOptions)
    .pipe(map((response: any) => response));
}

 getCustomCourses(page: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
 
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'CustomCourseDetailsBasedOnCategory?category=' + page, httpOptions)
      .pipe(map((response: any) => response));
  }

   purchaseCustomCourse(reqData:any, token:any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    // return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_custom_course', reqData, httpOptions)
    return this.http.post(this.AppConfig.API_ENDPOINT1 + 'payment_start_custom_course_with_easebuzz', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }
  
  getProductDetails(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    // return this.http.get(this.AppConfig.API_ENDPOINT + 'product_get?product_id=' + id, httpOptions)
    return this.http.get(this.AppConfig.API_ENDPOINT + 'ProductGetBasedOnName?product_name=' + id, httpOptions)

      .pipe(map((response: any) => response));
  }

}